import React, { FC, useCallback, useEffect, useRef } from "react";
import { IoIosClose } from "react-icons/io";
import Draggable from "react-draggable";

type ModalProps = {
    fields: React.ReactNode;
    title: string;
    show: boolean;
    setShow: (show: boolean) => void;
    className?: string;
    hoa?: boolean;
    overrideDismissMethod?: any;
};

const Modal: FC<ModalProps> = ({ fields, title, show, setShow, className, hoa, overrideDismissMethod }) => {
    const modalRef = useRef<HTMLDivElement>(null);

    const handleEscape = useCallback((e: any) => {
        if (e.key === 'Escape') {
            setShow(false);
        }
    }, [setShow]);

    useEffect(() => {
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [handleEscape]);

    function dismissModal(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        if (overrideDismissMethod) {
            overrideDismissMethod();
        }
        setShow(false);
    }

    const ModalHeader = () => (
        <div className={`rounded-t-lg pr-3 flex justify-between items-center ${hoa ? 'bg-highlight-1' : 'bg-highlight-5'} text-text-0 handler cursor-pointer`}>
            <div className="gap-2 items-center p-4">
                <h2 className="cursor-pointer text-lg font-semibold">{title}</h2>
            </div>
            <button
                className="flex text-3xl hover:text-gray-800 text-text-0"
                onClick={dismissModal}
                aria-label="Close Modal"
            >
                <IoIosClose className="hover:text-highlight-7" />
            </button>
        </div>
    );

    return (
        <>
            {show && (
            <div className="overflow-y-auto overflow-x-hidden min-h-screen  fixed z-50 inset-0 overlay index model_overflow">
                    
                        <div className="flex items-center justify-center min-h-[calc(100%-1rem)] w-full">
                        <Draggable handle=".handler" bounds="parent">
                            <div
                                ref={modalRef}
                                className={`relative bg-text-0 rounded-lg shadow-xl border-surface-4 ${className} `}
                            >
                                <ModalHeader />
                                <div className="p-4 md:p-5">{fields}</div>
                            </div>
                            </Draggable>
                        </div>
                    
                </div>
            )}
        </>
    );
};

export default Modal;
